module.exports = __webpack_public_path__ + "static/media/Collections-intimate-celebration-Mobile.4f2fae68.webp";